import { createFileRoute } from '@tanstack/react-router'

import { OrchestrationStudio } from '@/features/orchestration/components/OrchestrationStudio'

/** Home route — the orchestration studio. */
export const Route = createFileRoute('/')({
  component: OrchestrationStudio,
})
